import { createFileRoute, Outlet } from "@tanstack/react-router";

// Pathless layout for /o/$slug/employees/* — gives both the directory
// (employees/) and the detail (employees/$companyId/$ordioIdentityId) a
// common parent without forcing them into a single component.
export const Route = createFileRoute("/o/$slug/employees")({
  component: () => <Outlet />,
});
